/**
 * Giant icon layout on the delivery list card.
 *
 * Shared box for every giant, relative to the delivery_card plaque (left 111, top 541).
 * Display uses object-fit: contain inside width×height so PNG aspect ratio is preserved.
 */
import { GIANT_IDS, type GiantId } from '../../../../../../domain/ids/ids';

export type DeliveryCardGiantLayout = {
  left: number;
  top: number;
  width: number;
  height: number;
  /** Mean of X/Y design÷png scales (layout AABB may differ from PNG aspect). */
  scale: number;
};

/** PNG yellow bar ends ~207; icon sits below it. */
export const DELIVERY_CARD_GIANT_LAYOUT: DeliveryCardGiantLayout = {
  left: 77,
  top: 222,
  width: 260,
  height: 260,
  scale: 1,
};

/** Same yetti box for every GiantId. */
export const DELIVERY_CARD_GIANT_LAYOUTS: Record<
  GiantId,
  DeliveryCardGiantLayout
> = Object.fromEntries(
  GIANT_IDS.map((id) => [id, DELIVERY_CARD_GIANT_LAYOUT]),
) as Record<GiantId, DeliveryCardGiantLayout>;

export function getDeliveryCardGiantLayout(
  _giantId: GiantId,
): DeliveryCardGiantLayout {
  return DELIVERY_CARD_GIANT_LAYOUT;
}
